export default __webpack_public_path__ + "static/media/menuIconBlack.a4f48690.svg";